import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import FiscalSalesZreportComponent from './fiscal-sales-zreport.component';

let FiscalSalesZreportModule = angular
  .module('FiscalSalesZreport', [
    uiRouter
  ])
  .component('fiscalSalesZreport', FiscalSalesZreportComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('fiscalSalesZreport', {
      url: '/fiscal-sales-zreport',
      data: {
        authRequired: true,
        permsRequired: ['sales-zreport']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'fiscalSalesZreport'
        }
      }
    });
  })
  .name;

export default FiscalSalesZreportModule;



// WEBPACK FOOTER //
// ./src/app/pages/fiscal-sales-zreport/fiscal-sales-zreport.module.js